export default __webpack_public_path__ + "static/SRUS P123 - Especification Del Producto y Datos Técnicos-156b894adb09a67516345824d6fe9eea.pdf";